import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListaMunicipais from '../../components/leis/listar/municipais';


function MunicipaisScreen () {
    return (
        <Fragment>
            <Head titulo="Legislação do Município de Macuco"/>
            <Header />
            <Container>
                <ListaMunicipais />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default MunicipaisScreen;